import i18n from 'src/i18n'

const msg_m = 'commons.time.months.'
const msg_d = 'commons.time.day_abbreviations.'

export const MONTHS: string[] = [
  i18n.t(`${msg_m}january`),
  i18n.t(`${msg_m}february`),
  i18n.t(`${msg_m}march`),
  i18n.t(`${msg_m}april`),
  i18n.t(`${msg_m}may`),
  i18n.t(`${msg_m}june`),
  i18n.t(`${msg_m}july`),
  i18n.t(`${msg_m}august`),
  i18n.t(`${msg_m}september`),
  i18n.t(`${msg_m}october`),
  i18n.t(`${msg_m}november`),
  i18n.t(`${msg_m}december`),
]

export const DAYS: string[] = [
  i18n.t(`${msg_d}mon`),
  i18n.t(`${msg_d}tue`),
  i18n.t(`${msg_d}wed`),
  i18n.t(`${msg_d}thu`),
  i18n.t(`${msg_d}fri`),
  i18n.t(`${msg_d}sat`),
  i18n.t(`${msg_d}sun`),
]
